import Editable from "./Editable";
import withTextLoader from "./TextLoader";

export default Editable;
export { withTextLoader };
